import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import InputField from '../../../../reusable-components/InputField';
import { required } from '../../../../utils/validations';
import Header from '../../../../reusable-components/Header';
import Footer from '../../../../reusable-components/Footer';
import Body from '../../../../reusable-components/Body';
import Spinner from '../../../../reusable-components/Spinner';
import PageHeader from '../../../../reusable-components/PageHeader';
import PageContent from '../../../../reusable-components/PageContent';
import PropTypes from 'prop-types';
import Files from 'react-files';
import '../../../../styles/files.less';
import { IoIosCloseCircle } from "react-icons/io";
import { Row, Col, Button } from 'react-bootstrap';

export default class UploadDocuments extends Component {
  constructor(props){
    super(props);
    this.state = {
      errors: null,
      docs: [],
      documentsRequired: true
    }
    this.onSubmit = this.onSubmit.bind(this);
  }

  getFiles(photolabel, file){
    this.setState({ [photolabel]: file });
  }
 
  onFilesError = (error, file) => {
    console.log('error code ' + error.code + ': ' + error.message)
  }

  onSubmit(e){
    e.preventDefault();
    const { saveUser, history, user, line_id, object_type, total_cost, object } = this.props;
    const { docs, documentsRequired } = this.state;
    if (documentsRequired) {
      let errorsFound = false;

      if (docs.length > 0) {
        this.setState({ errors: '' });
        const formData = new FormData();
        docs.forEach((doc, index) => { 
          if (doc.file === "") {
            doc.errors = "File required";
            let filesState = docs
            filesState[index] = doc
            this.setState({ docs: filesState });
            errorsFound = true;
          }
        });
        if (!errorsFound) {
          this.setState({ formData: formData });
          saveUser({...user, ...object, line_id, object_type, total_cost });
        }
      } else {
        this.setState({ errors: 'Please attach the necessary documents' });
      }
    } else {
      saveUser({...user, ...object, line_id, object_type, total_cost });
    }
  }

  componentDidMount() {
    const { documents } = this.props;
    let docs = [];
    if (documents && documents.length > 0) {
      documents.forEach(doc => {
        let docObj = {
          name: doc.WaterDocumentName,
          file: "",
          upload_file_name: "",
          sizeReadable: "",
          errors: "",
        }
        docs.push(docObj);
      });
      this.setState({ docs });
    } else {
      this.setState({ documentsRequired:  false });
    }
  }

  componentDidUpdate(prevProps) {
    const { uploadDocument, request_id } = this.props;
    if (request_id !== prevProps.request_id) {
      if (this.state.documentsRequired) {
        const formData = new FormData();
        this.state.docs.forEach(doc => { 
          formData.append('userfile[]', doc.file);
        });
        uploadDocument(formData, request_id);
      } else {
        uploadDocument(null, request_id);
      }
    }
  }

  render() {
    const { handleSubmit, isloading, isUploading } = this.props;

    let buttonState = isloading || isUploading ? <Spinner /> : "Doorgaan";

    return (
      <React.Fragment>
        <PageHeader title="Documenten" />
        <PageContent 
          title="Upload aub de onderstaande documenten."
          goBack={() => {
            this.props.history.goBack()
          }}
          moveNext={() => {}}
          cardClass="card-container"
          showFooter={true}
          hasSubmitBtn={true}
          hasBackBtn={true}
          formClassNames=""
          buttonState={isloading || isUploading}
          submitting={isloading || isUploading}
          btnDisabled={isloading || isUploading}
          handleSubmit={this.onSubmit}>
        <div className="files-content-container">
        { this.state.errors && 
          (<div className="alert alert-danger" role="alert">
            {this.state.errors}
          </div>)
        }
          { this.state.docs && this.state.docs.length > 0 ?
            this.state.docs.map((doc, index) => {
              return (
                <div className="form-row" key={index}>
                  <div className="form-group col-md-12">
                    <label className="">{doc.name}</label>
                    <div className="files">
                      <Files
                        className='files-dropzone'
                        onChange={(_files) => {
                          doc.file = _files[0]
                          doc.upload_file_name = _files[0].name
                          doc.sizeReadable = _files[0].sizeReadable
                          doc.errors = "";
                          let filesState = this.state.docs
                          filesState[index] = doc
                          this.setState({ docs: filesState });
                        }}
                        onError={this.onFilesError}
                        accepts={['image/png', '.pdf', '/image/jpg', '/image/jpeg']}
                        multiple={false}
                        maxFileSize={10000000}
                        minFileSize={1}
                        clickable>
                        <p>
                            <span style={{marginRight: "10px"}}>
                                <i className="fa fa-upload"></i>
                            </span>
                            Drop file to upload, or  <a className="btn " style={{fontSize: '10px', marginLeft: '10px', padding: '8px 20px', color: 'white'}}>BROWSE</a>
                        </p>
                      </Files>
                      { doc.upload_file_name && 
                        <p>{doc.upload_file_name} - {doc.sizeReadable} 
                        <IoIosCloseCircle 
                          size={24} 
                          color="red"
                          style={{ marginLeft: '5px', cursor: "pointer" }}
                          onClick={() => {
                            doc.file = ""
                            doc.upload_file_name = ""
                            doc.sizeReadable = ""
                            let filesState = this.state.docs
                            filesState[index] = doc
                            this.setState({ docs: filesState });
                          }} /></p> 
                      }
                      { doc.errors && <p style={{color: 'red'}}>{doc.errors}</p>}
                    </div>
                  </div>
                </div>
              )
            }) : (<div><p className="text-center">No documents to attach</p></div>)
          }
          {/*<Row>
            <Col md={12}>
              <div className="footer-btn-container">
                <Button 
                  className="btn back-btn"
                  onClick={() => {
                    this.props.history.goBack();
                  }}>Terug</Button>
                <Button
                  type="submit" 
                  className="btn continue-btn"
                  disabled={isloading || isUploading}>{buttonState}</Button>
              </div>
            </Col>
          </Row>*/}
          </div>
        </PageContent>
      </React.Fragment>
    );
  }
}

UploadDocuments.propTypes = {
  isloading: PropTypes.bool,
}

